import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { WjInputDate } from '@grapecity/wijmo.angular2.input';
import { WjAccordion } from '@grapecity/wijmo.angular2.nav';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4300Model } from './kymw4300.model';
import { KYMW4300OutputModel } from './vo/kymw4300-output.model';
import { RadioLabelComponent } from '../../../commons/kymw02/radio-label/radio-label.component';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { VMediumDutiesFormTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-duties-form-type-combo-box/vmedium-duties-form-type-combo-box.component';
import { NotNullTextAreaComponent } from '../../../commons/kymw02/not-null-text-area/not-null-text-area.component';
import { CheckboxLabelComponent } from '../../../commons/kymw02/checkbox-label/checkbox-label.component';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW0400Component } from '../../../commons/kymw04/kymw0400/kymw0400.component';
import { KYMW0400InputModel } from '../../../commons/kymw04/kymw0400/vo/kymw0400-input.model';
import { NotNullTextInputComponent } from '../../../commons/kymw02/not-null-text-input/not-null-text-input.component';
import { ClassCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';
import { MiddleClassCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/middle-class-code-combo-box/middle-class-code-combo-box.component';
import { SmallClassCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/small-class-code-combo-box/small-class-code-combo-box.component';
import { CodeComboBoxComponent } from '../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { CodeCheckBoxListComponent } from '../../../commons/kymw02/list/code-check-box-list/code-check-box-list.component';
import { DnaInfoCheckBoxListComponent } from '../../../commons/kymw02/list/dna-info-check-box-list/dna-info-check-box-list.component';
import { KYMW0400OutputModel } from '../../../commons/kymw04/kymw0400/vo/kymw0400-output.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { WjTabPanel } from '@grapecity/wijmo.angular2.nav';
import { OutputGoodsDnaListService } from './api-services/output-goods-dna-list.service';
import { OutputPlanGoodsDnaListService } from './api-services/output-plan-goods-dna-list.service';

/**
 * 商品ＤＮＡ情報一覧画面を管理するクラス
 *
 * @export KYMW4300Component
 * @class KYMW4300Component
 */
@Component({
  selector: 'app-kymw4300',
  templateUrl: 'kymw4300.component.html',
  styleUrls: ['kymw4300.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW4300Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;
  // model
  kymw4300Model: KYMW4300Model = new KYMW4300Model();

  // 画面項目部品
  @ViewChild('rbtn_GoodsBase', { static: true }) rbtn_GoodsBase: RadioLabelComponent;
  @ViewChild('txt_OrderCodeFrom', { static: true }) txt_OrderCodeFrom: OrderCodeTextInputComponent;
  @ViewChild('lbl_CatalogId_From', { static: true }) lbl_CatalogId_From: ElementRef;
  @ViewChild('txt_OrderCodeTo', { static: true }) txt_OrderCodeTo: OrderCodeTextInputComponent;
  @ViewChild('lbl_CatalogId_To', { static: true }) lbl_CatalogId_To: ElementRef;

  @ViewChild('tab_pCode', { static: true }) tab_pCode: WjTabPanel;
  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VMediumDutiesFormTypeComboBoxComponent;
  @ViewChild('tbx_PCode', { static: true }) tbx_PCode: ElementRef;
  @ViewChild('tbx_ItemCode', { static: true }) tbx_ItemCode: ElementRef;
  @ViewChild('tbx_ebaseSpecCode', { static: true }) tbx_ebaseSpecCode: ElementRef;
  @ViewChild('tbx_JANCode', { static: true }) tbx_JANCode: ElementRef;
  @ViewChild('tbx_MakerName', { static: true }) tbx_MakerName: ElementRef;
  @ViewChild('tbx_GuideGoodsName', { static: true }) tbx_GuideGoodsName: NotNullTextAreaComponent;
  @ViewChild('tbx_GuideStandardName', { static: true }) tbx_GuideStandardName: NotNullTextAreaComponent;

  @ViewChild('cmb_AdmitStatusGroup', { static: true }) cmb_AdmitStatusGroup: CodeComboBoxComponent;
  @ViewChild('chb_DutiesFormWeeklyDiv', { static: true }) chb_DutiesFormWeeklyDiv: CheckboxLabelComponent;
  @ViewChild('chb_DutiesFormSpotDiv', { static: true }) chb_DutiesFormSpotDiv: CheckboxLabelComponent;
  @ViewChild('lst_DutiesFormDaily', { static: true }) lst_DutiesFormDaily: CodeCheckBoxListComponent;
  @ViewChild('lst_DNAInfoList', { static: true }) lst_DNAInfoList: DnaInfoCheckBoxListComponent;

  @ViewChild('tbx_OrdrClientCode', { static: true }) tbx_OrdrClientCode: ElementRef;
  @ViewChild('tbx_OrdrClientKanji', { static: true }) tbx_OrdrClientKanji: NotNullTextInputComponent;
  @ViewChild('tbx_PayeeClientCode', { static: true }) tbx_PayeeClientCode: ElementRef;
  @ViewChild('tbx_PayeeClientKanji', { static: true }) tbx_PayeeClientKanji: NotNullTextInputComponent;

  @ViewChild('chb_Seikyou1', { static: true }) chb_Seikyou1: CheckboxLabelComponent;
  @ViewChild('chb_Seikyou2', { static: true }) chb_Seikyou2: CheckboxLabelComponent;
  @ViewChild('chb_Seikyou3', { static: true }) chb_Seikyou3: CheckboxLabelComponent;
  @ViewChild('chb_Seikyou4', { static: true }) chb_Seikyou4: CheckboxLabelComponent;
  @ViewChild('chb_Seikyou5', { static: true }) chb_Seikyou5: CheckboxLabelComponent;
  @ViewChild('chb_Seikyou6', { static: true }) chb_Seikyou6: CheckboxLabelComponent;
  @ViewChild('chb_Seikyou7', { static: true }) chb_Seikyou7: CheckboxLabelComponent;
  @ViewChild('chb_Seikyou8', { static: true }) chb_Seikyou8: CheckboxLabelComponent;

  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('cmb_MiddleClassification', { static: true }) cmb_MiddleClassification: MiddleClassCodeComboBoxComponent;
  @ViewChild('cmb_SmallClassification', { static: true }) cmb_SmallClassification: SmallClassCodeComboBoxComponent;

  @ViewChild('dtf_StartRegistDate', { static: true }) dtf_StartRegistDate: WjInputDate;
  @ViewChild('dtf_EndRegistDate', { static: true }) dtf_EndRegistDate: WjInputDate;
  @ViewChild('dtf_StartUpdateDate', { static: true }) dtf_StartUpdateDate: WjInputDate;
  @ViewChild('dtf_EndUpdateDate', { static: true }) dtf_EndUpdateDate: WjInputDate;

  @ViewChild('chk_DummyGoods', { static: true }) chk_DummyGoods: CheckboxLabelComponent;
  @ViewChild('cmb_BuyerCode', { static: true }) cmb_BuyerCode: CodeComboBoxComponent;
  @ViewChild('chk_DealStopGoodsDisplay', { static: true }) chk_DealStopGoodsDisplay: CheckboxLabelComponent;
  @ViewChild('txta_PcodeList', { static: true }) txta_PcodeList: ElementRef;

  @ViewChild('btn_ConditionClear', { static: true }) btn_ConditionClear: ElementRef;

  // 検索条件VO
  private outputVO: KYMW4300OutputModel = new KYMW4300OutputModel();

  // 取引先一覧検索条件VOクラスの呼び出し区分値
  // 発注先
  public readonly SUPPLIER_FLAG_ORDER: string = <string>'0';
  // 支払先
  public readonly SUPPLIER_FLAG_PAYEE: string = <string>'1';

  // 生協コード
  // いばらき
  public readonly COOP_CODE_IBARAKI: string = <string>this.kymw00Model.COOP_CODE_IB;
  // とちぎ
  public readonly COOP_CODE_TOCHIGI: string = <string>this.kymw00Model.COOP_CODE_TO;
  // ぐんま
  public readonly COOP_CODE_GUNNMA: string = <string>this.kymw00Model.COOP_CODE_GU;
  // ちば
  public readonly COOP_CODE_CHIBA: string = <string>this.kymw00Model.COOP_CODE_TI;
  // さいたま
  public readonly COOP_CODE_SAITAMA: string = <string>this.kymw00Model.COOP_CODE_SA;
  // とうきょう
  public readonly COOP_CODE_TOKYO: string = <string>this.kymw00Model.COOP_CODE_TK;
  // ながの
  public readonly COOP_CODE_NAGANO: string = <string>this.kymw00Model.COOP_CODE_NA;
  // にいがた
  public readonly COOP_CODE_NIIGATA: string = <string>this.kymw00Model.COOP_CODE_NI;
  // クルコ
  public readonly COOP_CODE_KURUCO: string = <string>this.kymw00Model.COOP_CODE_KU;

  //Pコードリスト件数
  pcodeCount: number = 0;

  /**
   *Creates an instance of KYMW4300Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW4300Component
   */
  constructor(
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private dialogServiceSub: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private outputGoodsDnaListService: OutputGoodsDnaListService,
    private outputPlanGoodsDnaListService: OutputPlanGoodsDnaListService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4300';

    document.getElementById('txta_PcodeList').addEventListener('input', () => this.eventFileNameListHandler());

    // 「条件クリア」ボタン押下の処理化を呼び出し
    this.eventConditionClearHandler();

    // 初期フォーカス制御
    setTimeout(() => {
      this.plessEnabledSetting();
    });
  }

  /**
   * 条件クリアボタン押下イベント処理。
   */
  public eventConditionClearHandler(): void {

    // 商品マスタラジオボタンを選択状態にする
    this.kymw4300Model.rbtg_targetGoods = '1';

    // 受注コードFrom
    // 非活性
    this.txt_OrderCodeFrom.disabled = true;
    // テキストを空にする
    this.txt_OrderCodeFrom.text = '';
    this.txt_OrderCodeFrom.selectedCatalogID = '';
    this.kymw4300Model.catalogId_From = '';

    // 受注コードTo
    // 非活性
    this.txt_OrderCodeTo.disabled = true;
    // テキストを空にする
    this.txt_OrderCodeTo.text = '';
    this.txt_OrderCodeTo.selectedCatalogID = '';
    this.kymw4300Model.catalogId_To = '';

    // 媒体区分
    // 非活性
    this.cmb_MediumType.disabled = true;
    // 未選択にする
    this.cmb_MediumType.selectedMediumType = '';
    this.cmb_MediumType.updateSelectedMediumType();

    // Ｐコード
    this.kymw4300Model.pCode = '';

    // アイテムコード
    this.kymw4300Model.itemCode = '';
    // 訂正元eBASE NO
    this.kymw4300Model.eBaseSpecCode = '';
    // ＪＡＮコード
    this.kymw4300Model.jANCode = '';
    // メーカー名
    this.kymw4300Model.makerName = '';
    // 商品案内用商品名
    this.tbx_GuideGoodsName.text = '';
    // 商品案内用規格名
    this.tbx_GuideStandardName.text = '';

    // 発注先
    this.kymw4300Model.ordrClientCode = '';
    this.tbx_OrdrClientKanji.text = '';
    // 支払先
    this.kymw4300Model.payeeClientCode = '';
    this.tbx_PayeeClientKanji.text = '';

    // 部門
    this.cmb_ClassCode.setClassCode('');						// 未選択にする（中分類、小分類は自動的に未選択になる）
    // 登録日
    this.dtf_StartRegistDate.text = '';				      // テキストを空にする
    this.dtf_EndRegistDate.text = '';				        // テキストを空にする
    // 更新日
    this.dtf_StartUpdateDate.text = '';				      // テキストを空にする
    this.dtf_EndUpdateDate.text = '';				        // テキストを空にする
    // 取扱可能生協
    // 未選択にする
    this.chb_Seikyou1.selected = false;
    this.chb_Seikyou2.selected = false;
    this.chb_Seikyou3.selected = false;
    this.chb_Seikyou4.selected = false;
    this.chb_Seikyou5.selected = false;
    this.chb_Seikyou6.selected = false;
    this.chb_Seikyou7.selected = false;
    this.chb_Seikyou8.selected = false;

    // 登録レベル
    this.cmb_AdmitStatusGroup.setCodeValue('0');                 //「全体」にする
    // バイヤーコード
    this.cmb_BuyerCode.setCodeValue('');						            // 未選択にする
    // Ｐコードリスト
    this.kymw4300Model.pCodeList = '';
    // ダミー商品
    this.chk_DummyGoods.selected = false;			                  // 未選択にする
    // 業態区分（ウィークリー）
    this.chb_DutiesFormWeeklyDiv.selected = false;			        // 未選択にする
    // 業態区分（スポット）
    this.chb_DutiesFormSpotDiv.selected = false;			          // 未選択にする
    // 業態区分（ウィークリー）
    this.chb_DutiesFormWeeklyDiv.disabled = true;			          // 非活性
    // 業態区分（スポット）
    this.chb_DutiesFormSpotDiv.disabled = true;			            // 非活性
    // 業態区分（デイリー）
    this.lst_DutiesFormDaily.updateCheckCodeValue(null, false);	// 全チェックをＯＦＦにする。
    // 取引停止商品を出力
    this.chk_DealStopGoodsDisplay.selected = false;			        // 未選択にする
    this.chk_DealStopGoodsDisplay.disabled = false;			        // 活性
    // ＤＮＡ区分リスト
    this.lst_DNAInfoList.updateCheckCodeValue(null, false);		  // 全チェックをＯＦＦにする

    this.pcodeCount = 0;                                        // Pコード件数を0にする
  }

  /**
   * 初期表示時の制御
   *
   * @memberof KYMW0800Component
   */
  plessEnabledSetting() {
    this.rbtn_GoodsBase.setFocus();
    this.txt_OrderCodeFrom.disabled = true;
    this.txt_OrderCodeTo.disabled = true;

    // 日付の直接入力を不可能にする
    // マスタ登録日
    this.dtf_StartRegistDate.hostElement.tabIndex = 0;
    this.dtf_EndRegistDate.hostElement.tabIndex = 0;
    // マスタ更新日
    this.dtf_StartUpdateDate.hostElement.tabIndex = 0;
    this.dtf_EndUpdateDate.hostElement.tabIndex = 0;
  }

  /**
   * 商品マスタ、商品企画マスタラジオボタン切り替えイベント処理。
   */
  public rbtg_targetGoods_CHANGEHandler(): void {

    // 選択値のチェック
    if (this.kymw4300Model.rbtg_targetGoods === '1') {

      // 「1:商品マスタ」の場合
      // 受注コードFrom
      this.txt_OrderCodeFrom.disabled = true;		// 非活性
      // 受注コードTo
      this.txt_OrderCodeTo.disabled = true;		// 非活性
      // 媒体区分
      this.cmb_MediumType.disabled = true;		// 非活性
      // 取扱停止商品
      this.chk_DealStopGoodsDisplay.disabled = false;			// 活性
      // 業態区分（ウィークリー）
      this.chb_DutiesFormWeeklyDiv.disabled = true;		// 非活性
      // 業態区分（スポット）
      this.chb_DutiesFormSpotDiv.disabled = true;		// 非活性
    } else if (this.kymw4300Model.rbtg_targetGoods === '2') {

      // 「2:商品企画マスタ」の場合
      // 受注コードFrom
      this.txt_OrderCodeFrom.disabled = false;			// 活性
      // 受注コードTo
      this.txt_OrderCodeTo.disabled = false;			// 活性
      // 媒体区分
      this.cmb_MediumType.disabled = false;			// 活性
      // 取扱停止商品
      this.chk_DealStopGoodsDisplay.disabled = true;		// 非活性
      // 業態区分（ウィークリー）
      this.chb_DutiesFormWeeklyDiv.disabled = false;			// 活性
      // 業態区分（スポット）
      this.chb_DutiesFormSpotDiv.disabled = false;			// 活性
    }
  }

  /**
   * 発注先の検索ボタンを押下イベント処理。
   */
  public eventSearchOrdrClientHandler(): void {

    // 取引先一覧画面を起動
    const componentRef = this.dialogServiceSub.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;

    // 「発注先ポップアップ用インプットVO」の生成
    const vo: KYMW0400InputModel = new KYMW0400InputModel();
    // VOに値を設定
    vo.supplierFlg = this.SUPPLIER_FLAG_ORDER;	// 発注先

    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0400Parameter = (outputVo: KYMW0400OutputModel) => {
      // 取引先一覧画面からの戻り処理
      this.setKYMW0400Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 取引先のインターフェースの実装
   *
   * @copy jp.co.toppan.pless.KYMW04.IKYMW0400#setKYMW0400Parameter()
   */
  public setKYMW0400Parameter(outputVO: KYMW0400OutputModel): void {

    if (outputVO.supplierFlg === this.SUPPLIER_FLAG_ORDER) {
      // 発注先
      this.kymw4300Model.ordrClientCode = outputVO.supplierCode;
      this.tbx_OrdrClientKanji.text = outputVO.supplierNameKanji;
    } else if (outputVO.supplierFlg === this.SUPPLIER_FLAG_PAYEE) {
      // 支払先
      this.kymw4300Model.payeeClientCode = outputVO.supplierCode;
      this.tbx_PayeeClientKanji.text = outputVO.supplierNameKanji;
    }
  }


  /**
   * 支払先の検索ボタン押下イベント処理。
   */
  public eventSearchPayeeHandler(): void {

    // 取引先一覧画面を起動
    const componentRef = this.dialogServiceSub.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;

    // 「支払先ポップアップ用インプットVO」の生成
    const vo: KYMW0400InputModel = new KYMW0400InputModel();
    // VOに値を設定
    vo.supplierFlg = this.SUPPLIER_FLAG_PAYEE;	// 支払先

    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0400Parameter = (outputVo: KYMW0400OutputModel) => {
      // 取引先一覧画面からの戻り処理
      this.setKYMW0400Parameter(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 登録日Fromと登録日Toの押下処理
   *
   * @param event コールバック・イベントへの参照
   */
  public eventRegistDateHandler(event: Event): void {
    if (PlessViewUtilsSub.isEmpty(this.dtf_StartRegistDate.text)
      || PlessViewUtilsSub.isEmpty(this.dtf_EndRegistDate.text)) {
      return;
    } else if (this.dtf_StartRegistDate.text > this.dtf_EndRegistDate.text) {
      // 日付のFromよりToの方が日付が小さい場合はエラー表示する。
      this.dialogServiceSub.openAlertGetMessage('E0123', ['登録日'],
        (closeEvent) => {
          if (closeEvent === PlessAlert.Yes_Error) {
            this.dtf_StartRegistDate.text = '';
          }
        }
      );
    }
  }

  /**
   * 更新日Fromと更新日Toの押下処理
   *
   * @param event コールバック・イベントへの参照
   */
  public eventUpdateDateHandler(event: Event): void {
    if (PlessViewUtilsSub.isEmpty(this.dtf_StartUpdateDate.text)
      || PlessViewUtilsSub.isEmpty(this.dtf_EndUpdateDate.text)) {
      return;
    } else if (this.dtf_StartUpdateDate.text > this.dtf_EndUpdateDate.text) {
      // 日付のFromよりToの方が日付が小さい場合はエラー表示する。
      this.dialogServiceSub.openAlertGetMessage('E0123', ['更新日'],
        (closeEvent) => {
          if (closeEvent === PlessAlert.Yes_Error) {
            this.dtf_StartUpdateDate.text = '';
          }
        }
      );
    }
  }

  /**
   * 「条件クリア」ボタンからのタブ切り替え処理
   *
   */
  public eventMoveToListSeachTabHandler(event: Event): void {
    // 通常検索タブの時
    if (this.tab_pCode.selectedIndex === 0) {
      // 次のフォーカス切り替え処理を呼び出し（Pコードリストにタブを切り替える）
      this.nextFocus(this.btn_ConditionClear, event);
    }
  }

  /**
   * Ｐコードリストに入力した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventFileNameListHandler(): void {
    const array: any = PlessViewUtilsSub.formatList(this.kymw4300Model.pCodeList.split('\n'), 200);
    this.kymw4300Model.pCodeList = PlessViewUtilsSub.arrayToString(array, '\n');

    // 改行された数だけ件数をカウントする
    if ( array.length === 1 && array[0] === "") {
      this.pcodeCount = 0;
    } else {
      this.pcodeCount = array.length;
    }
  }

  /**
   * 出力ボタン押下処理
   *
   * @param event コールバック・イベントへの参照
   */
  public eventOutput_CLICKHandler(event: Event): void {
    // 出力ボタンを押下した時の必須項目入力チェック
    if (!this.inputCheck()) {
      return;
    }

    // 通常検索タブ選択時
    if (this.tab_pCode.selectedIndex === 0) {
      // 検索条件がすべて未入力であればメッセージ表示
      if (!this.checkSerchCondition()) {
        this.dialogServiceSub.openAlertGetMessage('E0143');
        return;
      }
    } else {
      // リスト検索タブ選択時
      // 検索条件がすべて未入力であればメッセージ表示
      if (!this.checkListSerchCondition()) {
        this.dialogServiceSub.openAlertGetMessage('E0143');
        return;
      }
    }

    // 選択値のチェック
    if (this.kymw4300Model.rbtg_targetGoods === '1') {
      // 「1:商品マスタ」の場合
      // VO設定
      this.outputVO = this.createOutputVO();
      this.outputGoodsDnaListService.execute(this.kymw4300Model, this.outputVO, (serverData: any) => {
        // サーバファイル名の保存
        this.kymw4300Model.updateFileName(serverData);
        // ローカルファイル名の作成
        const fileName = '商品ＤＮＡデータ_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.csv';
        // ダウンロードの確認画面を起動する
        this.fileDownloadConfirmService.show(serverData.FileName, fileName);
      });
    } else if (this.kymw4300Model.rbtg_targetGoods === '2') {
      // 「2:商品企画マスタ」の場合
      // VO設定
      this.outputVO = this.createOutputVO();
      this.outputPlanGoodsDnaListService.execute(this.kymw4300Model, this.outputVO, (serverData: any) => {
        // サーバファイル名の保存
        this.kymw4300Model.updateFileName(serverData);
        // ローカルファイル名の作成
        const fileName = '商品企画ＤＮＡデータ_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.csv';
        // ダウンロードの確認画面を起動する
        this.fileDownloadConfirmService.show(serverData.FileName, fileName);
      });
    }
  }

  /**
   * 検索条件を元にKYMW4300OutputVOを生成
   */
  private createOutputVO(): KYMW4300OutputModel {
    // VOの初期化
    const outputVO = new KYMW4300OutputModel();

    // 商品企画マスタ選択時のみ
    if (this.kymw4300Model.rbtg_targetGoods === '2') {
      // 受注コードFrom
      outputVO.orderCodeFrom = this.kymw4300Model.orderCodeFrom;
      // 受注コードTo
      outputVO.orderCodeTo = this.kymw4300Model.orderCodeTo;
      // 媒体区分
      if (PlessViewUtilsSub.isEmpty(this.cmb_MediumType.selectedMediumType)) {
        // 媒体区分が未選択時は空文字
        outputVO.mediumType = '';
      } else {
        outputVO.mediumType = this.cmb_MediumType.selectedMediumType;
      }
    }

    // 「0：通常検索」タブ選択時
    if (this.tab_pCode.selectedIndex === 0) {
      // Ｐコード
      outputVO.pcode = this.kymw4300Model.pCode;
      // アイテムコード
      outputVO.itemCode = this.kymw4300Model.itemCode;
      // 訂正元eBASE NO
      outputVO.ebaseSpecCode = this.kymw4300Model.eBaseSpecCode;
      // ＪＡＮコード
      outputVO.janCode = this.kymw4300Model.jANCode;
      // メーカー名
      outputVO.makerName = this.kymw4300Model.makerName;
      // 商品案内用商品名
      outputVO.guideGoodsNameList = this.replaceAll(PlessViewUtilsSub.trim(this.tbx_GuideGoodsName.text)).split(' ');
      // 商品案内用規格名
      outputVO.guideStandardNameList = this.replaceAll(PlessViewUtilsSub.trim(this.tbx_GuideStandardName.text)).split(' ');
      // 発注先コード
      outputVO.ordrClientCode = this.kymw4300Model.ordrClientCode;
      // 発注先名
      outputVO.ordrClientKanji = this.tbx_OrdrClientKanji.text;
      // 支払先コード
      outputVO.payeeClientCode = this.kymw4300Model.payeeClientCode;
      // 支払先名
      outputVO.payeeClientKanji = this.tbx_PayeeClientKanji.text;
      // 部門
      outputVO.classCode = this.cmb_ClassCode.selectedClassCode;
      // 中分類
      outputVO.middleClassCode = this.cmb_MiddleClassification.selectedMiddleClassCode;
      // 小分類
      outputVO.smallClassCode = this.cmb_SmallClassification.selectedSmallClassCode;
      // 登録日
      outputVO.registDateFrom = this.dtf_StartRegistDate.text;
      outputVO.registDateTo = this.dtf_EndRegistDate.text;
      // 更新日
      outputVO.updateDateFrom = this.dtf_StartUpdateDate.text;
      outputVO.updateDateTo = this.dtf_EndUpdateDate.text;
      // 取扱可能生協
      outputVO.coopCodeList = this.getCoopCodeArray();
      // 登録レベル
      outputVO.admitStatus = CodeComboBoxComponent.convertToParentAdminStatus(this.cmb_AdmitStatusGroup.selectedCodeValue);
      // バイヤーコード
      if (PlessViewUtilsSub.isEmpty(this.cmb_BuyerCode.selectedCodeValue)) {
        // チェックがない場合は空文字を返す
        outputVO.buyerCode = '';
      } else {
        // バイヤーコードに入力された値を返す。
        outputVO.buyerCode = this.cmb_BuyerCode.selectedCodeValue;
      }
      // ダミー商品
      if (this.chk_DummyGoods.selected) {
        // チェックが入ってる場合は「１」 を返す
        outputVO.goodsDiv = '1';
      } else {
        // チェックがない場合は空文字を返す
        outputVO.goodsDiv = '';
      }
      // 業態区分（ウィークリー）
      if (this.chb_DutiesFormWeeklyDiv.selected) {
        // チェックが入ってる場合は「１」 を返す
        outputVO.dutiesFormWeekly = '1';
      } else {
        // チェックがない場合は空文字を返す
        outputVO.dutiesFormWeekly = '';
      }
      // 業態区分（スポット） チェックが入ってる場合は「１」 チェックがない場合は空文字を格納
      if (this.chb_DutiesFormSpotDiv.selected) {
        // チェックが入ってる場合は「１」 を返す
        outputVO.dutiesFormSpot = '1';
      } else {
        // チェックがない場合は空文字を返す
        outputVO.dutiesFormSpot = '';
      }
      // 業態区分(デイリー）
      const items: Array<any> = new Array<any>();				// 選択アイテム配列
      const list: Array<any> = new Array<any>();		// 選択コードリスト
      // 選択コードリストを取得
      const selectedDailyArray: Array<any> = new Array<any>();
      for (let i = Number(0); i < this.lst_DutiesFormDaily.codeList.length; i++) {
        if (this.lst_DutiesFormDaily.codeList[i].selectedValue) {
          // チェックが入っている項目の業態区分（デイリー）のコード値を返す
          selectedDailyArray.push(this.lst_DutiesFormDaily.codeList[i].CodeValue);
        }
      }
      outputVO.dutiesFormDailyList = selectedDailyArray;	// チェックONの業態区分(デイリー）リスト

      // ＤＮＡ情報取得
      // ★
      const itemsDNA: Array<any> = new Array<any>();				// 選択アイテム配列
      const listDNA: Array<any> = new Array<any>();		// 選択コードリスト
      // 選択コードリストを取得
      const selectedDailyArray0: Array<any> = new Array<any>();
      for (let y = 0; y < this.lst_DNAInfoList.codeList.length; y++) {
        if (this.lst_DNAInfoList.codeList[y].selectedValue[0]) {
          // チェックが入っている項目のＤＮＡ区分値を返す
          selectedDailyArray0.push(this.lst_DNAInfoList.codeList[y].DnaDiv);
        }
      }
      outputVO.dnaDivList = selectedDailyArray0;	// チェックONの商品ＤＮＡリスト

      // 選択値チェック
      if (this.kymw4300Model.rbtg_targetGoods === '1') {
        // 「1:商品マスタ」の場合
        // 取引停止商品を出力
        if (this.chk_DealStopGoodsDisplay.selected) {
          // チェックが入ってる場合は「１」 を返す
          outputVO.dealStopGoodsDisplay = '1';
        } else {
          // チェックがない場合は場合は「0」 を返す
          outputVO.dealStopGoodsDisplay = '0';
        }
      }
    } else if (this.tab_pCode.selectedIndex === 1) {
      // 「1：リスト検索タブ選択時」
      // 入力された値をEnter区切りでリストにし、返す
      outputVO.pcodeList = this.outputVO.pcodeList;
      // リスト検索タブ選択時は検索区分「1」を返す
      outputVO.searchKbn = 1;
    }

    return outputVO;
  }

  // Pコードリストに200件未満の制御
  private formatPcodeList(ary: any): Array<any> {
    if (ary.length > 200) {
      const newArray: Array<any> = new Array<any>();

      for (let i = Number(0); i < 200; i++) {
        newArray.push(ary[i]);
      }
      return newArray;
    } else {
      return ary;
    }
  }

  /**
   * Arrayのデータを文字列に変換。
   */
  private arrayToString(baseArray: any, delimita: string): string {
    if (baseArray === null) {
      return null;
    }
    let returnString: string;
    for (let i = Number(0); i < baseArray.length; i++) {
      if (i === 0) {
        returnString = baseArray[i];
      } else {
        returnString = returnString + delimita + baseArray[i];
      }
    }
    return returnString;
  }

  /**
   * 生協コードを取得
   * チェックされた生協のみArrayにセットし返却
   */
  private getCoopCodeArray(): Array<any> {
    const returnArray: Array<any> = new Array<any>();
    if (this.chb_Seikyou1.selected) {
      returnArray.push(this.COOP_CODE_IBARAKI);	// いばらき
    }
    if (this.chb_Seikyou2.selected) {
      returnArray.push(this.COOP_CODE_TOCHIGI);	// とちぎ
    }
    if (this.chb_Seikyou3.selected) {
      returnArray.push(this.COOP_CODE_GUNNMA);	// ぐんま
    }
    if (this.chb_Seikyou4.selected) {
      returnArray.push(this.COOP_CODE_CHIBA);	// ちば
    }
    if (this.chb_Seikyou5.selected) {
      returnArray.push(this.COOP_CODE_SAITAMA);	// さいたま
    }
    if (this.chb_Seikyou6.selected) {
      returnArray.push(this.COOP_CODE_TOKYO);	// とうきょう
    }
    if (this.chb_Seikyou7.selected) {
      returnArray.push(this.COOP_CODE_NAGANO);	// ながの
    }
    if (this.chb_Seikyou8.selected) {
      returnArray.push(this.COOP_CODE_NIIGATA);	// にいがた
    }
    return returnArray;
  }

  /**
   * 全角の空白を半角の空白に返す。
   * replace()メソッドを呼びだす。
   */
  private replaceAll(trg: string): string {
    let returnString: string = trg;
    while (returnString.indexOf('　') > -1) {
      returnString = returnString.replace('　', ' ');
    }
    return returnString;
  }

  /**
   * 出力ボタンを押下した時の必須項目入力チェック
   */
  private inputCheck(): boolean {
    // 商品企画マスタ選択時エラーチェック
    if (!PlessViewUtilsSub.isEmpty(this.kymw4300Model.rbtg_targetGoods)
      && this.kymw4300Model.rbtg_targetGoods === '2') {

      this.kymw4300Model.orderCodeFrom = this.txt_OrderCodeFrom.text;
      this.kymw4300Model.orderCodeTo = this.txt_OrderCodeTo.text;
      this.kymw4300Model.catalogId_From = this.txt_OrderCodeFrom.selectedCatalogID;
      this.kymw4300Model.catalogId_To = this.txt_OrderCodeTo.selectedCatalogID;

      // 受注コードFrom必須チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw4300Model.orderCodeFrom)) {
        this.dialogServiceSub.openAlertGetMessage('W0001', ['受注コード(From)']);
        // 処理復帰
        return false;
      }

      // 受注コードTo必須チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw4300Model.orderCodeTo)) {
        this.dialogServiceSub.openAlertGetMessage('W0001', ['受注コード(To)']);

        // 処理復帰
        return false;
      }

      // 配達企画回（翌週）（From）存在チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw4300Model.catalogId_From)) {
        this.dialogServiceSub.openAlertGetMessage('W0024', ['受注コード(From)']);

        // 処理復帰
        return false;
      }

      // 配達企画回（翌週）（To）存在チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw4300Model.catalogId_To)) {
        this.dialogServiceSub.openAlertGetMessage('W0024', ['受注コード(To)']);

        // 処理復帰
        return false;
      }

      // 配達企画回（翌週）（From） > 配達企画回（翌週）（To）チェック
      if (Number(this.kymw4300Model.catalogId_From)
        > Number(this.kymw4300Model.catalogId_To)) {
        this.dialogServiceSub.openAlertGetMessage('E0125', ['受注コード(From)', '受注コード(To)']);

        // 処理復帰
        return false;
      }
    }

    return true;
  }

  /**
   * 検索条件の必須チェックを行う
   * 登録レベル + ひとつでも値があれば、trueを返す
   */
  private checkSerchCondition(): boolean {

    // 登録レベル
    if (PlessViewUtilsSub.isEmpty(this.cmb_AdmitStatusGroup.selectedCodeValue)) {
      return false;
    }

    // Ｐコード
    if (!PlessViewUtilsSub.isEmpty(this.kymw4300Model.pCode)) {
      return true;
    }

    // アイテムコード
    if (!PlessViewUtilsSub.isEmpty(this.kymw4300Model.itemCode)) {
      return true;
    }

    // 訂正元eBASE NO
    if (!PlessViewUtilsSub.isEmpty(this.kymw4300Model.eBaseSpecCode)) {
      return true;
    }

    // ＪＡＮコード
    if (!PlessViewUtilsSub.isEmpty(this.kymw4300Model.jANCode)) {
      return true;
    }

    // メーカー名
    if (!PlessViewUtilsSub.isEmpty(this.kymw4300Model.makerName)) {
      return true;
    }

    // 商品案内用商品名
    if (!PlessViewUtilsSub.isEmpty(this.tbx_GuideGoodsName.text)) {
      return true;
    }

    // 商品案内用規格名
    if (!PlessViewUtilsSub.isEmpty(this.tbx_GuideStandardName.text)) {
      return true;
    }

    // 発注先コード
    if (!PlessViewUtilsSub.isEmpty(this.kymw4300Model.ordrClientCode)) {
      return true;
    }

    // 発注先名
    if (!PlessViewUtilsSub.isEmpty(this.tbx_OrdrClientKanji.text)) {
      return true;
    }

    // 支払先コード
    if (!PlessViewUtilsSub.isEmpty(this.kymw4300Model.payeeClientCode)) {
      return true;
    }

    // 支払先名
    if (!PlessViewUtilsSub.isEmpty(this.tbx_PayeeClientKanji.text)) {
      return true;
    }

    // 部門
    if (!PlessViewUtilsSub.isEmpty(this.cmb_ClassCode.selectedClassCode)) {
      return true;
    }

    // 中分類
    if (!PlessViewUtilsSub.isEmpty(this.cmb_MiddleClassification.selectedMiddleClassCode)) {
      return true;
    }

    // 小分類
    if (!PlessViewUtilsSub.isEmpty(this.cmb_SmallClassification.selectedSmallClassCode)) {
      return true;
    }

    // 登録日
    if (!PlessViewUtilsSub.isEmpty(this.dtf_StartRegistDate.text)) {
      // 登録日From
      return true;
    } else if (!PlessViewUtilsSub.isEmpty(this.dtf_EndRegistDate.text)) {
      // 登録日To
      return true;
    }

    // 更新日
    if (!PlessViewUtilsSub.isEmpty(this.dtf_StartUpdateDate.text)) {
      // 更新日From
      return true;
    } else if (!PlessViewUtilsSub.isEmpty(this.dtf_EndUpdateDate.text)) {
      // 更新日To
      return true;
    }

    // 取扱可能生協 いばらき
    if (this.chb_Seikyou1.selected) {
      return true;
    }

    // 取扱可能生協 とちぎ
    if (this.chb_Seikyou2.selected) {
      return true;
    }

    // 取扱可能生協 ぐんま
    if (this.chb_Seikyou3.selected) {
      return true;
    }

    // 取扱可能生協 ちば
    if (this.chb_Seikyou4.selected) {
      return true;
    }

    // 取扱可能生協 さいたま
    if (this.chb_Seikyou5.selected) {
      return true;
    }

    // 取扱可能生協 とうきょう
    if (this.chb_Seikyou6.selected) {
      return true;
    }

    // 取扱可能生協 ながの
    if (this.chb_Seikyou7.selected) {
      return true;
    }

    // 取扱可能生協 にいがた
    if (this.chb_Seikyou8.selected) {
      return true;
    }

    // バイヤーコード
    if (!PlessViewUtilsSub.isEmpty(this.cmb_BuyerCode.selectedCodeValue)) {
      return true;
    }

    // ダミー商品
    if (this.chk_DummyGoods.selected) {
      return true;
    }
    // 選択チェック
    if (this.kymw4300Model.rbtg_targetGoods === '2') {
      // 「2:商品企画マスタ」の場合
      // 業態区分（ウィークリー）
      if (this.chb_DutiesFormWeeklyDiv.selected) {
        return true;
      }

      // 業態区分（スポット）
      if (this.chb_DutiesFormSpotDiv.selected) {
        return true;
      }
    }

    // 業態区分（デイリー）
    for (let i = Number(0); i < this.lst_DutiesFormDaily.codeList.length; i++) {
      if (this.lst_DutiesFormDaily.codeList[i].selectedValue === true) {
        return true;
      }
    }

    // DNA情報
    for (let n = Number(0); n < this.lst_DNAInfoList.codeList.length; n++) {
      if (this.lst_DNAInfoList.codeList[n].selectedValue[0] === true) {
        return true;
      }
    }
    // 選択値チェック
    if (this.kymw4300Model.rbtg_targetGoods === '1') {
      // 「1:商品マスタ」の場合
      if (this.chk_DealStopGoodsDisplay.selected === true) {
        return true;
      }
    }
    return false;
  }

  /**
   * リスト検索タブ選択時エラーチェック
   */
  private checkListSerchCondition(): boolean {
    // Pコードリストの必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw4300Model.pCodeList)) {
      return false;
    }

    // 取得した項目をリストに格納する
    const check_pcodeList: Array<any>
      = PlessViewUtilsSub.trim(this.kymw4300Model.pCodeList).split('\n');
    // Pコードリストの初期化
    this.outputVO.pcodeList = new Array<any>();

    // 格納した値が空文字でないことをチェックする
    for (let i = Number(0); i < check_pcodeList.length; i++) {
      if (!PlessViewUtilsSub.isEmpty(String(check_pcodeList[i]))) {
        // 空文字でなければ入力された値をVOに返す
        this.outputVO.pcodeList.push(check_pcodeList[i]);
      }
    }

    // リストが０件の場合エラーコードを返す
    // 改行のみが入力された場合などは必須チェックでエラーにならないため記述
    if (this.outputVO.pcodeList.length === 0) {
      return false;
    }
    return true;
  }

  /**
   * タブキーによるフォーカス移動（タブの最後の項目→次のタブ先頭）
   */
  public nextFocus(obj: ElementRef, e: any): void {

    if (obj === this.btn_ConditionClear) {
      if (e.keyCode === 9 && !e.shiftKey) {
        // 後続のデフォルトイベントをキャンセル
        event.preventDefault();

        // タブ移動
        this.tab_pCode.selectedIndex = 1;
      }
    }
  }

  /**
   * 受注コードFrom変更処理
   *
   * @memberof KYMW4300Component
   */
  public clickChangeCatalogIdFrom(): void {
    this.kymw4300Model.catalogId_From = this.txt_OrderCodeFrom.selectedCatalogID;
  }

  /**
   * 受注コードTo変更処理
   *
   * @memberof KYMW4300Component
   */
  public clickChangeCatalogIdTo(): void {
    this.kymw4300Model.catalogId_To = this.txt_OrderCodeTo.selectedCatalogID;
  }

  public initCollapsed(wad: WjAccordion, collapsed: boolean = true) {
    wad.panes.forEach(_ => (_.isCollapsed = collapsed));
  }
}
